export default "__VITE_ASSET__ce67ecc0__"